(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-pair-beach-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cc-setup]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const cards = Array.from(root.querySelectorAll('[data-cc-offer-select]'));
      const panels = Array.from(root.querySelectorAll('[data-cc-builder]'));
      const beachbinInput = root.querySelector('[data-cc-beachbin]');
      const chairHandle = 'clean-coastal-inflatable-beach-chairs';
      const savings = { pair: 1998, family: 4994 };
      const currency = window.Shopify?.currency?.active || 'USD';

      const route = (path) => (window.Shopify?.routes?.root || '/') + path.replace(/^\/+/, '');
      const money = (cents) => new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        { style: 'currency', currency }
      ).format(Number(cents || 0) / 100);
      const optionData = (select, component) => {
        const option = select.options[select.selectedIndex];
        return { id: option.value, price: Number(option.dataset.price || 0), component };
      };
      const beachbinData = () => ({ id: beachbinInput.value, price: Number(beachbinInput.dataset.price || 0), component: 'beachbin' });

      const itemsFor = (offer) => {
        const panel = root.querySelector(`[data-cc-builder="${offer}"]`);
        const chairs = Array.from(panel.querySelectorAll('[data-cc-chair]')).map((select) => optionData(select, 'chair'));
        if (offer === 'family') {
          return chairs.concat([optionData(panel.querySelector('[data-cc-family-blanket]'), 'blanket'), beachbinData()]);
        }
        const accessory = panel.querySelector('input[name^="cc-pair-essential-"]:checked')?.value;
        return chairs.concat([
          accessory === 'blanket'
            ? optionData(panel.querySelector('[data-cc-pair-blanket]'), 'blanket')
            : beachbinData()
        ]);
      };

      const refresh = (offer) => {
        const panel = root.querySelector(`[data-cc-builder="${offer}"]`);
        if (offer === 'pair') {
          const isBlanket = panel.querySelector('input[name^="cc-pair-essential-"]:checked')?.value === 'blanket';
          const wrap = panel.querySelector('[data-cc-pair-blanket-wrap]');
          wrap.hidden = !isBlanket;
          wrap.querySelector('select').disabled = !isBlanket;
        }
        const subtotal = itemsFor(offer).reduce((sum, item) => sum + item.price, 0);
        const total = Math.max(0, subtotal - savings[offer]);
        panel.querySelector('[data-cc-subtotal]').textContent = money(subtotal);
        panel.querySelector('[data-cc-total]').textContent = money(total);
        panel.querySelector('[data-cc-add]').textContent = `Add ${offer === 'pair' ? 'Couples' : 'Family'} Beach Kit — ${money(total)}`;
        root.querySelector(`[data-cc-card-price="${offer}"]`).textContent = `From ${money(total)}`;
      };

      const activate = (offer) => {
        cards.forEach((card) => {
          const active = card.dataset.ccOfferSelect === offer;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-selected', String(active));
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.ccBuilder !== offer; });
        refresh(offer);
      };

      const rollback = async (added) => {
        const updates = {};
        (added?.items || []).forEach((item) => { if (item.key) updates[item.key] = 0; });
        if (!Object.keys(updates).length) return;
        await fetch(route('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
      };

      const addOffer = async (offer, button) => {
        const panel = root.querySelector(`[data-cc-builder="${offer}"]`);
        const status = panel.querySelector('[data-cc-status]');
        const discountCode = offer === 'pair' ? root.dataset.pairCode : root.dataset.familyCode;
        let added = null;
        button.disabled = true;
        button.textContent = 'Adding your kit…';
        status.textContent = '';

        try {
          const cartResponse = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          if (!cartResponse.ok) throw new Error('We could not load your cart.');

          const existingChairs = (cart.items || [])
            .filter((item) => item.handle === chairHandle)
            .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
          if (existingChairs > 0) throw new Error('Remove the chair already in your cart first so this kit prices correctly.');

          const grouped = new Map();
          itemsFor(offer).forEach((item) => {
            const key = `${item.id}:${item.component}`;
            const current = grouped.get(key) || { ...item, quantity: 0 };
            current.quantity += 1;
            grouped.set(key, current);
          });
          const items = Array.from(grouped.values()).map((item) => ({
            id: Number(item.id),
            quantity: item.quantity,
            properties: { _cc_offer: `${offer}_kit`, _cc_component: item.component }
          }));

          const addResponse = await fetch(route('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          added = await addResponse.json();
          if (!addResponse.ok) throw new Error(added.description || 'We could not add this kit.');

          const updateResponse = await fetch(route('cart/update.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              attributes: { _cc_offer: `${offer}_kit` },
              discount: discountCode,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname || '/cart'
            })
          });
          const updated = await updateResponse.json();
          if (!updateResponse.ok) throw new Error(updated.description || 'We could not apply the kit savings.');

          const codeStatus = (updated.discount_codes || []).find((entry) => String(entry.code || '').toUpperCase() === String(discountCode).toUpperCase());
          if (codeStatus && codeStatus.applicable === false) throw new Error('The kit savings could not be applied. Please try again.');

          status.textContent = `${offer === 'pair' ? 'Couples' : 'Family'} Beach Kit added with ${money(savings[offer])} savings.`;
          button.disabled = false;
          refresh(offer);

          const drawer = document.querySelector('cart-drawer');
          if (drawer?.renderContents && updated.sections) {
            drawer.setActiveElement?.(button);
            drawer.renderContents(updated);
            return;
          }
          window.location.href = route('cart');
        } catch (error) {
          if (added?.items) {
            try { await rollback(added); } catch (_) {}
          }
          status.textContent = error.message || 'We could not add this kit. Please try again.';
          button.disabled = false;
          refresh(offer);
        }
      };

      cards.forEach((card) => card.addEventListener('click', () => activate(card.dataset.ccOfferSelect)));
      panels.forEach((panel) => {
        panel.querySelectorAll('select, input[type="radio"]').forEach((field) => field.addEventListener('change', () => refresh(panel.dataset.ccBuilder)));
        panel.querySelector('[data-cc-add]').addEventListener('click', (event) => addOffer(panel.dataset.ccBuilder, event.currentTarget));
      });
      refresh('pair');
      refresh('family');
      activate('pair');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
